export const DOOR_TYPES = {
  SWINGING: 'Swinging',
  SLIDING: 'Sliding',
  DOUBLE: 'Double',
};
export const DOOR_LOCATIONS = {
  FRONT_DOOR: 'Front Door',
  SIDE_DOOR: 'Side Door',
  BACK_DOOR: 'Back Door',
  PATIO_DOOR: 'Patio Door',
};
export const DOOR_COLORS = {
  WHITE: 'White',
  TAN: 'Tan',
  GREY: 'Grey',
  BLACK: 'Black',
  WOOD_TEXTURE: 'Wood texture',
};
export const DOOR_STYLES = {
  NO_GLASS: 'No Glass',
  PARTIAL_GLASS: 'Partial Glass',
  FULL_GLASS: 'Full Glass',
  TWO_PANELS: '2 Panels',
  THREE_PANELS: '3 Panels',
  FOUR_PANELS: '4 Panels',
  CUSTOM: 'Custom',
};

export const WINDOW_STYLES = [
  {
    text: 'Opens up and down',
    itemsList: [
      {
        text: 'Bathroom',
      },
      {
        text: 'Grids (lines in window)',
      },
      {
        text: 'Oversized (larger than 4ft x 4ft)',
      },
    ],
  },
  {
    text: 'Opens left to right',
    itemsList: [
      {
        text: 'Bathroom',
      },
      {
        text: 'Grids (lines in window)',
      },
      {
        text: 'Oversized (larger than 4ft x 4ft)',
      },
    ],
  },
  {
    text: 'Fixed',
    itemsList: [
      {
        text: 'Bathroom',
      },
      {
        text: 'Grids (lines in window)',
      },
      {
        text: 'Oversized (larger than 4ft x 4ft)',
      },
    ],
  },
  {
    text: 'Cranks open',
    itemsList: [
      {
        text: 'Bathroom',
      },
      {
        text: 'Basement',
      },
      {
        text: 'Grids (lines in window)',
      },
      {
        text: 'Oversized (larger than 4ft x 4ft)',
      },
    ],
  },
];

export const TYPES_LIST = [
  {
    name: DOOR_TYPES.SWINGING,
  },
  {
    name: DOOR_TYPES.SLIDING,
  },
  {
    name: DOOR_TYPES.DOUBLE,
  },
];

export const LOCATIONS_LIST = [
  {
    name: DOOR_LOCATIONS.FRONT_DOOR,
  },
  {
    name: DOOR_LOCATIONS.SIDE_DOOR,
  },
  {
    name: DOOR_LOCATIONS.BACK_DOOR,
  },
  {
    name: DOOR_LOCATIONS.PATIO_DOOR,
  },
];

export const COLORS = {
  [DOOR_TYPES.SWINGING]: [
    {
      name: DOOR_COLORS.WHITE,
      path: '/assets/icons/project-details/door-color-1.svg',
    },
    {
      name: DOOR_COLORS.TAN,
      path: '/assets/icons/project-details/door-color-2.svg',
    },
    {
      name: DOOR_COLORS.GREY,
      path: '/assets/icons/project-details/door-color-3.svg',
    },
    {
      name: DOOR_COLORS.BLACK,
      path: '/assets/icons/project-details/door-color-4.svg',
    },
    {
      name: DOOR_COLORS.WOOD_TEXTURE,
      path: '/assets/icons/project-details/door-color-5.svg',
    },
  ],
  [DOOR_TYPES.SLIDING]: [
    {
      name: DOOR_COLORS.WHITE,
      path: '/assets/icons/project-details/door-color-1.svg',
    },
    {
      name: DOOR_COLORS.TAN,
      path: '/assets/icons/project-details/door-color-2.svg',
    },
    {
      name: DOOR_COLORS.BLACK,
      path: '/assets/icons/project-details/door-color-4.svg',
    },
    {
      name: DOOR_COLORS.WOOD_TEXTURE,
      path: '/assets/icons/project-details/door-color-5.svg',
    },
  ],
  [DOOR_TYPES.DOUBLE]: [
    {
      name: DOOR_COLORS.WHITE,
      path: '/assets/icons/project-details/door-color-1.svg',
    },
    {
      name: DOOR_COLORS.TAN,
      path: '/assets/icons/project-details/door-color-2.svg',
    },
    {
      name: DOOR_COLORS.GREY,
      path: '/assets/icons/project-details/door-color-3.svg',
    },
    {
      name: DOOR_COLORS.BLACK,
      path: '/assets/icons/project-details/door-color-4.svg',
    },
    {
      name: DOOR_COLORS.WOOD_TEXTURE,
      path: '/assets/icons/project-details/door-color-5.svg',
    },
  ],
};

export const STYLES = {
  [DOOR_COLORS.WHITE]: [
    {
      path: '/assets/icons/project-details/door-no-glass-1.svg',
      name: DOOR_STYLES.NO_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-partial-glass-1.svg',
      name: DOOR_STYLES.PARTIAL_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-full-glass-1.svg',
      name: DOOR_STYLES.FULL_GLASS,
    },
  ],
  [DOOR_COLORS.TAN]: [
    {
      path: '/assets/icons/project-details/door-no-glass-2.svg',
      name: DOOR_STYLES.NO_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-partial-glass-2.svg',
      name: DOOR_STYLES.PARTIAL_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-full-glass-2.svg',
      name: DOOR_STYLES.FULL_GLASS,
    },
  ],
  [DOOR_COLORS.GREY]: [
    {
      path: '/assets/icons/project-details/door-no-glass-3.svg',
      name: DOOR_STYLES.NO_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-partial-glass-3.svg',
      name: DOOR_STYLES.PARTIAL_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-full-glass-3.svg',
      name: DOOR_STYLES.FULL_GLASS,
    },
  ],
  [DOOR_COLORS.BLACK]: [
    {
      path: '/assets/icons/project-details/door-no-glass-4.svg',
      name: DOOR_STYLES.NO_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-partial-glass-4.svg',
      name: DOOR_STYLES.PARTIAL_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-full-glass-4.svg',
      name: DOOR_STYLES.FULL_GLASS,
    },
  ],
  [DOOR_COLORS.WOOD_TEXTURE]: [
    {
      path: '/assets/icons/project-details/door-no-glass-5.svg',
      name: DOOR_STYLES.NO_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-partial-glass-5.svg',
      name: DOOR_STYLES.PARTIAL_GLASS,
    },
    {
      path: '/assets/icons/project-details/door-full-glass-5.svg',
      name: DOOR_STYLES.FULL_GLASS,
    },
  ],
};

export const SLIDING_STYLES = {
  [DOOR_COLORS.WHITE]: [
    {
      path: '/assets/icons/project-details/door-two-panels-1.svg',
      name: DOOR_STYLES.TWO_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-three-panels-1.svg',
      name: DOOR_STYLES.THREE_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-four-panels-1.svg',
      name: DOOR_STYLES.FOUR_PANELS,
    },
  ],
  [DOOR_COLORS.TAN]: [
    {
      path: '/assets/icons/project-details/door-two-panels-2.svg',
      name: DOOR_STYLES.TWO_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-three-panels-2.svg',
      name: DOOR_STYLES.THREE_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-four-panels-2.svg',
      name: DOOR_STYLES.FOUR_PANELS,
    },
  ],
  [DOOR_COLORS.BLACK]: [
    {
      path: '/assets/icons/project-details/door-two-panels-4.svg',
      name: DOOR_STYLES.TWO_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-three-panels-4.svg',
      name: DOOR_STYLES.THREE_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-four-panels-4.svg',
      name: DOOR_STYLES.FOUR_PANELS,
    },
  ],
  [DOOR_COLORS.WOOD_TEXTURE]: [
    {
      path: '/assets/icons/project-details/door-two-panels-5.svg',
      name: DOOR_STYLES.TWO_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-three-panels-5.svg',
      name: DOOR_STYLES.THREE_PANELS,
    },
    {
      path: '/assets/icons/project-details/door-four-panels-5.svg',
      name: DOOR_STYLES.FOUR_PANELS,
    },
  ],
};

export const TOPICS = {
  FINANCING_PLANS: 'financing-plans',
  ENERGY_EFFICIENCY: 'energy-efficiency',
  INSTALLATION_PROCESS: 'installation-process',
  FINANCING_TIPS: 'financing-tips',
};

export const TOPICS_LIST = [
  {
    unique_name: TOPICS.FINANCING_PLANS,
    title: 'Financing options',
  },
  {
    unique_name: TOPICS.ENERGY_EFFICIENCY,
    title: 'Window materials',
  },
  {
    unique_name: TOPICS.INSTALLATION_PROCESS,
    title: 'Installation',
  },
  {
    unique_name: TOPICS.FINANCING_TIPS,
    title: 'Financing Tips',
  },
];

export const BLOG_POST_LIST = [
  {
    unique_name: TOPICS.ENERGY_EFFICIENCY,
    title: 'Energy Efficiency',
    text: '<p>We sell some of the most energy efficient windows that could lower your monthly utility bills.</p>',
    image: {
      description: 'Woman adjusting her Thermostat',
      url: 'assets/images/energy-efficiency.jpg',
    },
    read_more_button: {
      text: 'Explore Energy Efficiency',
      link: 'energy-efficiency',
    },
  },
  {
    unique_name: TOPICS.FINANCING_PLANS,
    title: 'Financing Plans',
    text: '<p>Window Nation’s budget-friendly financing options could help ensure you get the best deal.</p>',
    image: {
      description: 'Couple looking at a phone and laptop',
      url: 'assets/images/financing-plans.jpg',
    },
    read_more_button: {
      text: 'Explore Financing Plans',
      link: 'financing-plans',
    },
  },
  {
    unique_name: TOPICS.INSTALLATION_PROCESS,
    title: 'Installation Process',
    text: '<p>Our 20-point installation check ensures your windows fit well – and last for decades.</p>',
    image: {
      description: 'Man on a ladder installing windows',
      url: 'assets/images/installation-process.jpg',
    },
    read_more_button: {
      text: 'Explore Installation Process',
      link: 'installation-process',
    },
  },
  {
    unique_name: TOPICS.FINANCING_TIPS,
    title: 'Financing Tips',
    text: '<p>Financing can be overwhelming. That’s why we’ve built this handy tool to help you see which options are best for your needs.</p>',
    image: {
      description: 'Woman on her couch looking at her laptop',
      url: 'assets/images/financing-tips.jpg',
    },
    read_more_button: {
      text: 'Explore Financing Tips',
      link: 'financing-education',
    },
  },
];
